import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DESIGN_NOW_FALLBACK_URL, getDesignNowUrl } from "../utils/designNow";

let designNowUrlRequest;
const loadDesignNowPath = () => {
  // All Design Now links share the API request across the site.
  if (!designNowUrlRequest) designNowUrlRequest = getDesignNowUrl();
  return designNowUrlRequest;
};

const DesignNowLink = ({ children, onClick, ...props }) => {
  const navigate = useNavigate();
  const [designerPath, setDesignerPath] = useState(null);

  useEffect(() => {
    let active = true;
    loadDesignNowPath().then((path) => {
      if (active) setDesignerPath(path);
    });
    return () => {
      active = false;
    };
  }, []);

  const handleClick = (event) => {
    // Menu items must leave navigation to Link.
    event.stopPropagation();
    onClick?.(event);

    if (
      !designerPath &&
      !event.defaultPrevented &&
      event.button === 0 &&
      !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey &&
      (!props.target || props.target === "_self")
    ) {
      // An early click still uses the API's product once it finishes loading.
      event.preventDefault();
      loadDesignNowPath().then((path) => navigate(path));
    }
  };

  return (
    <Link {...props} to={designerPath || DESIGN_NOW_FALLBACK_URL} onClick={handleClick}>
      {children}
    </Link>
  );
};

export default DesignNowLink;
